import React from 'react';
import {Redirect} from "react-router-dom";
import CalendarPercent from "../../CalendarPercent/CalendarPercentContainer";
import CalendarSubscription from "../../CalendarSubscription/CalendarSubscriptionContainer";
import Preloader from "../Preloader/Preloader";
import DontHaveRooms from "./DontHaveRooms";


const PriceTableController = (props) => {
    const {paymentType, rooms, objectId} = props
    const matchRoomId = props.match.params.roomId




    if(!matchRoomId && !rooms || rooms?.length === 0) {
        return <DontHaveRooms objectId={objectId}/>
    }
    if(!matchRoomId) {
        return <Redirect to={`calendar/${rooms[0].id}`}/>
    }
    if(!paymentType) {
        return <Preloader loading={true}/>
    }

    return (
        <div className="main edit-object edit-calendar">
                {paymentType === "percent"
                    ? <CalendarPercent objectId={objectId} roomId={matchRoomId}/>
                    : <CalendarSubscription objectId={objectId}/>
                }
        </div>
    )
}

export default PriceTableController